
import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreVertical, Eye, Download, Printer, Edit, Trash2 } from 'lucide-react';

interface DocumentActionMenuProps {
  document: any;
  onView: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

export const DocumentActionMenu: React.FC<DocumentActionMenuProps> = ({
  document,
  onView,
  onDownload,
  onDelete
}) => {
  const handlePrint = () => {
    // Create a new window for printing the document
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      if (document.fileType.startsWith('image/')) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Print ${document.name}</title>
              <style>
                body { margin: 0; padding: 20px; }
                img { max-width: 100%; height: auto; }
                .header { text-align: center; margin-bottom: 20px; }
              </style>
            </head>
            <body>
              <div class="header">
                <h2>${document.name}</h2>
                <p>Printed on ${new Date().toLocaleDateString()}</p>
              </div>
              <img src="${document.fileData}" alt="${document.name}" />
            </body>
          </html>
        `);
      } else {
        printWindow.document.write(`
          <html>
            <head>
              <title>Print ${document.name}</title>
              <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                .header { text-align: center; margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 10px; }
              </style>
            </head>
            <body>
              <div class="header">
                <h2>${document.name}</h2>
                <p>Category: ${document.category}</p>
                <p>Printed on ${new Date().toLocaleDateString()}</p>
              </div>
              <p><strong>Description:</strong> ${document.description || 'No description'}</p>
              <p><strong>File Type:</strong> ${document.fileType}</p>
              <p><strong>File Size:</strong> ${(document.fileSize / 1024).toFixed(2)} KB</p>
              <p><strong>Upload Date:</strong> ${new Date(document.uploadDate).toLocaleDateString()}</p>
            </body>
          </html>
        `);
      }
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 w-8 p-0">
          <MoreVertical className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={onView} className="cursor-pointer">
          <Eye className="mr-2 h-4 w-4" />
          View Document
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDownload} className="cursor-pointer">
          <Download className="mr-2 h-4 w-4" />
          Download
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handlePrint} className="cursor-pointer">
          <Printer className="mr-2 h-4 w-4" />
          Print
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDelete} className="cursor-pointer text-red-600">
          <Trash2 className="mr-2 h-4 w-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
